import UsersIcon from './component'

export default UsersIcon
